/**
 * API Client für Produkt-KPI und tägliche Umsatz-Zeitreihen
 */
import { apiClient } from '@/lib/api-client'

const API_BASE = '/api/v1'

// =============================================================================
// TYPES
// =============================================================================

export type ProductKpiSummary = {
  active_count: number
  without_packshot_count: number
  revenue_30d_total: number
  revenue_prev_30d_total: number
  revenue_delta_pct: number | null
  with_issues_count: number
}

export type DailyPoint = {
  sale_date: string
  quantity: number
  revenue: number
}

// =============================================================================
// API FUNCTIONS
// =============================================================================

/**
 * Lädt KPI-Zusammenfassung für alle aktiven Produkte des Workspaces.
 * GET /api/v1/products/kpi-summary
 */
export async function getProductKpiSummary(): Promise<ProductKpiSummary> {
  const response = await apiClient.get<{ success: boolean; kpi: ProductKpiSummary }>(
    `${API_BASE}/products/kpi-summary`
  )
  return response.data.kpi
}

/**
 * Lädt tägliche Umsatz-Zeitreihen für die angegebenen Produkte.
 * GET /api/v1/products/sales-daily?product_ids=<csv>&days=<days>
 *
 * @param productIds - Produkt-IDs; leeres Array gibt sofort {} zurück
 * @param days - Anzahl Tage (default 30)
 */
export async function getSalesDaily(
  productIds: string[],
  days: number = 30
): Promise<Record<string, DailyPoint[]>> {
  if (!productIds.length) return {}

  const response = await apiClient.get<{ success: boolean; series: Record<string, DailyPoint[]> }>(
    `${API_BASE}/products/sales-daily`,
    { params: { product_ids: productIds.join(','), days } }
  )
  return response.data.series ?? {}
}
